import { useEffect } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export default function Lightbox({ images, index, onClose, onPrev, onNext }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") onPrev();
      if (e.key === "ArrowRight") onNext();
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose, onPrev, onNext]);

  return (
    <div
      className="lightbox-backdrop"
      data-testid="lightbox"
      onClick={onClose}
    >
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); onClose(); }}
        className="absolute top-5 right-5 w-11 h-11 rounded-full border border-gold/40 text-gold bg-ink-900/70 hover:bg-burgundy/40 flex items-center justify-center"
        aria-label="Close"
        data-testid="lightbox-close"
      >
        <X size={18} />
      </button>
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); onPrev(); }}
        className="absolute left-3 md:left-8 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full border border-gold/40 text-gold bg-ink-900/70 hover:bg-burgundy/40 flex items-center justify-center"
        aria-label="Previous"
        data-testid="lightbox-prev"
      >
        <ChevronLeft size={22} />
      </button>
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); onNext(); }}
        className="absolute right-3 md:right-8 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full border border-gold/40 text-gold bg-ink-900/70 hover:bg-burgundy/40 flex items-center justify-center"
        aria-label="Next"
        data-testid="lightbox-next"
      >
        <ChevronRight size={22} />
      </button>

      <figure
        className="relative max-w-5xl w-full max-h-[85vh] flex items-center justify-center"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={images[index]}
          alt={`Memory ${index + 1}`}
          className="max-h-[85vh] w-auto rounded-2xl shadow-[0_20px_80px_rgba(0,0,0,0.7)] border border-gold/30"
        />
        <figcaption className="absolute -bottom-10 inset-x-0 text-center text-[0.65rem] uppercase tracking-[0.4em] text-gold">
          #PandA · {index + 1} / {images.length}
        </figcaption>
      </figure>
    </div>
  );
}
